import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export default {
  install: Vue => {
    Object.defineProperty(Vue.prototype, "$dayjs", { value: dayjs });
  }
};
